import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
Vue.use(Vuex)

function get_name() {
  const name = window.localStorage['type_name']
  return name || ''
}
function get_user_data() {
  const data = window.localStorage['user_data']
  if (data) {
    return JSON.parse(data)
  } else return {}
}
export default new Vuex.Store({
  state: {
    companyID: '',
    isLoading: false, //下拉刷新loading状态
    ajax_ing: false, //当前是否ajax请求未结束
    page_tigger: false, //触发分页加载
    filter_status: false, //过滤面板状态
    loading: false, //ajax加载时loaing
    show_top: '', //是否显示返回顶部图标
    user_data: get_user_data() //用户信息
  },
  mutations: {
    set_isLoading: (state, data) => {
      state.isLoading = data
    },
    set_filter_status: (state, data) => {
      if (data === undefined) {
        state.filter_status = !state.filter_status
      } else {
        state.filter_status = data
      }
    },
    set_ajax_ing: (state, data) => {
      state.ajax_ing = data
    },
    set_page_tigger: state => {
      state.page_tigger = !state.page_tigger
    },
    set_show_top: (state, data) => {
      state.show_top = data
    },
    set_user_data: (state, data) => {
      state.user_data = data
    },
    set_companyID: (state, data) => {
      state.companyID = data
    },
    set_loading: (state, data) => {
      state.loading = data
    }
  },
  actions: {},
  modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js